import React from 'react';
import HeroSection from '../sections/home/hero/HeroSection';
import PositioningSection from '../sections/home/positioning/PositioningSection';
import ServicesSection from '../sections/home/services/ServicesSection';
import WorkSection from '../sections/home/work/WorkSection';
import TransitionSection from '../sections/home/transition/TransitionSection';
import ProcessSection from '../sections/home/process/ProcessSection';
import CtaSection from '../sections/home/cta/CtaSection';

const HomePage = () => (
    <>
        <HeroSection />
        <PositioningSection />
        <ServicesSection />
        <WorkSection />
        <TransitionSection />
        <ProcessSection />
        <CtaSection />
    </>
);

export default HomePage;
